module.exports = __webpack_public_path__ + "static/media/lamp.9533e2ce.jpg";